import useFormattedDate from './useFormattedDate';
export * from './useFormattedDate';

export default useFormattedDate;
